/**
 * CompanyUpdated.contract.ts — Event Contract System™ (generation v1).
 * DOMAIN INTEGRATION HARDENING sprint: an existing CRM company record changed
 * (update or deletion) through the Career Domain Service.
 */

import type { EventContract } from '../EventContractRegistry';

export const CompanyUpdatedContract: EventContract = {
  name: 'CompanyUpdated',
  version: 1,
  description: 'An existing CRM company record changed (updated/deleted) via Career™.',
  publishers: ['career-domain'],
  subscribers: ['companies-page'],
  fields: [
    { name: 'companyId', type: 'number', required: true, description: 'API company id affected' },
    { name: 'changeKind', type: 'string', required: true, description: "'updated' | 'deleted'" },
  ],
  allowExtraFields: true,
  timestampPolicy: 'Publish time (Date.now()) after the API mutation succeeds.',
  stability: 'stable',
  deprecated: false,
  example: { companyId: 7, changeKind: 'updated' },
};
